import styled from "styled-components";

export const StyledRating = styled.div`
  height: 20px;
`;

export const StyledNoOfRatings = styled.div`
  font-size: 12px;
  color: #666;
  position: relative;
  top: 2px;
`;

export const StyledRatingComment = styled.div`
  border-bottom: solid 1px #efefef;
  margin-bottom: 10px;
  padding-bottom: 10px;
`;

export const StyledRatingName = styled.div`
  font-weight: bold;
`;

export const StyledUserAvatar = styled.span`
  max-width: 50px;
  padding: 0 10px 0 0;
`;

export const StyledStarContainer = styled.div`
  margin-top: 1rem;
`;

export const StyledOuterContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const StyledHalfInnerContainer = styled.div`
  height: 100%;
  width: 100%;

  .error {
    margin: 0;
  }

  label {
    display: flex;
    flex-direction: column;
  }

  textarea {
    width: 100%;
    max-width: 100%;
    margin-bottom: 1rem;
  }
`;

export const StyledHalfInnerButtonContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
`;
